<template>
  <DialogFull :data="dialogSettings" @close="close">
    <template v-slot:dialog.body>
      <div class="container col-lg-8 col-sm-12 self-schedule-invites">
        <div v-if="isFetchingInterviewInvites">
          <v-skeleton-loader
            v-for="i in 5"
            :key="i"
            type="list-item-three-line"
            class="my-2"
          />
        </div>
        <div v-else>
          <div
            v-for="(invitation, index) in interviewInvites"
            :key="index"
            class="my-0"
          >
            <SelfScheduleInviteListItem :invitation="invitation" />
          </div>
        </div>
      </div>
    </template>
    <template v-slot:dialog.action>
      <Permissioned :vertical="isMobile" section="interviews">
        <SelfScheduleInviteAction permission="schedule" />
      </Permissioned>
    </template>
  </DialogFull>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { INTERVIEWS_NAMESPACE } from "@/store/modules/bookings/interviews";
import { FETCH_INTERVIEW_INVITES } from "@/store/modules/bookings/interviews/actions";
import { copyState } from "@/utils/helpers";
import DialogFull from "@/components/common/DialogFull";
import SelfScheduleInviteAction from "@/views/bookings/BookingInterviews/components/actions/SelfScheduleInviteAction";
import SelfScheduleInviteListItem from "@/views/bookings/BookingInterviews/components/dialogs/SelfScheduleInvites/components/SelfScheduleInviteListItem";
import Permissioned from "@/components/common/Permissioned";

const {
  mapActions: mapInterviewActions,
  mapState: mapInterviewState
} = createNamespacedHelpers(INTERVIEWS_NAMESPACE);

export default {
  props: {
    isOpen: Boolean
  },
  components: {
    DialogFull,
    SelfScheduleInviteAction,
    SelfScheduleInviteListItem,
    Permissioned
  },
  created() {
    this.fetchInterviewInvites(this.currentBookingId);
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Self-Schedule Invites"
      };
    },
    ...mapInterviewState(
      copyState(["interviewInvites", "isFetchingInterviewInvites"])
    ),
    currentBookingId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapInterviewActions({
      fetchInterviewInvites: FETCH_INTERVIEW_INVITES
    }),
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
